import { AxiosResponse } from 'axios';

import { QueryObserverOptions, useQueryClient } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

/** @category useCheckDuplicateId */
export type TypeCheckDuplicateIdParams = {
  /** 로그인 아이디 */
  username: string;
};

/** @category useCheckDuplicateId */
export type TypeCheckDuplicateIdResponse = {
  code: string;
  message: string;
  /** 아이디 중복 여부 */
  data: boolean;
};

/**
 * @description 회원가입 아이디 중복확인 api 요청에 사용되는 커스텀 훅
 */
export const useCheckDuplicateId = () => {
  const queryClient = useQueryClient();

  const requestCheckDuplicateId = async ({
    params,
    onSuccess,
    onError,
    queryConfig,
  }: {
    params: TypeCheckDuplicateIdParams;
    onSuccess?: (res: TypeCheckDuplicateIdResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
    queryConfig?: Omit<QueryObserverOptions<AxiosResponse<TypeCheckDuplicateIdResponse>>, 'queryKey' | 'queryFn'>;
  }) => {
    const endpoint = '/labor-accounts/username/exist';
    const query = queryClient.ensureQueryData<AxiosResponse<TypeCheckDuplicateIdResponse>>({
      queryKey: ['labor-accounts', 'username', 'exist', params.username],
      queryFn: () => axiosInstance.get(endpoint, { params, headers: { withoutToken: true } }),
      ...queryConfig,
      gcTime: 0,
    });

    return requestHelper(() => query, onSuccess, onError, undefined, { showLoading: false });
  };

  return requestCheckDuplicateId;
};
